module.exports = __webpack_public_path__ + "img/keyboard.efd2c053.svg";